<template>
    <span v-if="!params.node.rowPinned">
        <b-button v-if='false' class="align-baseline mr-1" :href="editGuestHref" variant="default">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button v-if='!redeemed' class="align-baseline" v-b-modal="deleteModalId" variant="default">
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalId"
            title="Delete Guest Credit"
            @shown="onModalShown"
            @ok="deleteGuestCredit"
        >Permanently delete {{guestName}} credit?</modal>
    </span>
</template>

<script>
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                guestId: 0,
                guestName: 'this guest',
                editGuestHref: '',
                deleteModalId: '',
            };
        },
        created() {
            this.guestId = this.params.data.id;
            this.redeemed = this.params.data.redeemed;
            const nameArr = [];
            if (this.params.data.first_name) {
                nameArr.push(this.params.data.first_name);
            }
            if (this.params.data.last_name) {
                nameArr.push(this.params.data.last_name);
            }
            const name = nameArr.join(' ');
            if (name) {
                this.guestName = `"${name}"`;
            }
            // TODO: replace :href with :to
            this.editGuestHref = `/app/guest/${this.guestId}/edit`;
            this.deleteModalId = `modal-delete-guest-${this.guestId}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            async deleteGuestCredit() {
                try {
                    await API.delete(`/app/guest/credit/list/${this.guestId}/`);
                    this.params.refresh()
                } catch (error) {
                    const response = error.response;
                    const detail =
                        response && response.data && response.data.detail
                            ? ' ' + response.data.detail
                            : '';
                    this.errorToast({ text: `Could not delete guest credit.${detail}`})
                    return;
                }
            },
        },
    };
</script>
